import { Component, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AppClientContext } from '../../_appCommon/base/AppClientContext';
import { AppEventNames } from '../../_appCommon/base/Constants';
import { BroadcastManager } from '../../_appCommon/base/BroadcastManager';
import { ControllerBase } from '../../_appCommon/base/ControllerBase';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { ECOMMERCE_USER_TOKEN } from '../../../app/_appCommon/base/Constants';
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';
import { SystemServicesDataService } from '../../../app/_dataservices/security/SystemServicesDataService';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  providers: [SystemServicesDataService, CustomerDataService, ShoppingCartDataService]
})
export class MainComponent extends ControllerBase
{
  public isUserLoggedIn = false;

  constructor(
    private customerDataService: CustomerDataService,
    private injector: Injector,
    private router: Router,
    private systemServicesDataService: SystemServicesDataService,
    public shoppingCartDataService: ShoppingCartDataService,
  )
  {
    super();
  }

  ngOnInit()
  {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if(event.url == '/ecommerce/checkout'){
        this.shoppingCartDataService.onShowShoppingCart(false);
      }
    });
    
    if (this.getUserLoginFromCache())
    {
      this.getStartupInfo();
      this.isUserLoggedIn = true;
    }
    else
    {
      this.router.navigate(['/']);
    }
  }

  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
          this.setDangerAlert('Usuario no autorizado');
        }
      });
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);

    // Save a reference to the angular injector to the client context
    AppClientContext.Instance.setInjector(this.injector);

    BroadcastManager.Instance.broadcast(AppEventNames.OnCheckUserLoggedIn, true);

    this.getCustomerInfo();
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentUser = response.items.firstOrNull();
          if (currentUser)
          {
            AppClientContext.Instance.customerId = currentUser.id;
            this.shoppingCartDataService.initializeShoppingCart();
          }
        });
    }
  }

  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  private getUserLoginFromCache(): boolean
  {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    return this.setSecurityToken(user);
  }

  private setSecurityToken(user: any): boolean
  {
    if (user && user.cacheToken)
    {
      // Remove Token
      AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

      // Append Token
      AppClientContext.Instance.headerValues.set(ECOMMERCE_USER_TOKEN, user.cacheToken);

      return true;
    }
    return false;
  }
}
